import { type ReactNode } from 'react';
import { useMedia } from 'react-use';
import { ResumeFunnelButton } from '@hungryroot/funnel';
import { BreakpointQueryLarge } from '@hungryroot/tokens';
import {
  HomepageIcon,
  Variant as HomepageIconVariant,
} from '../../HomepageIcon';

import styles from './HomeHeader.module.css';

type Props = {
  className?: string;
  action?: ReactNode;
  actionContainerClassName?: string;
};

export function HomeHeader(props: Props) {
  const { className, action, actionContainerClassName } = props;

  const isDesktop = useMedia(BreakpointQueryLarge, false);

  return (
    <header className={`${styles.container} ${className}`}>
      <nav className={styles.nav}>
        <HomepageIcon
          variant={HomepageIconVariant.DishLogo}
          className={styles.logo}
        />
        <div className={`${styles['nav-links']} ${actionContainerClassName}`}>
          {action}
          {isDesktop && (
            <ResumeFunnelButton
              startQuizText="Get started"
              style="success"
              prominence="primary"
              size="medium"
              className={styles.cta}
            />
          )}
        </div>
      </nav>
    </header>
  );
}
